// 引入vue
import Vue  from 'vue'
 
// 引入vuex
import Vuex from 'vuex'
import getters from './getters'
 
// 应用vue插件
Vue.use(Vuex)
 
// // actions响应组件中的动作
// const actions = {
// }
 
// // mutations操作数据state
// const mutations = {
// }
 
// // 准备state存储数据
// const state = {
//    //状态对象
// }
 
// // 创建store并导出
// const store = new Vuex.Store({
//         actions,
//         mutations,
//         state,
// })
 
 
// //默认导出store
// export default store

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  getters
})

export default store